import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import { makeStyles} from '@material-ui/core/styles';
import Successpop from './Successpop'




const useStyles = makeStyles((theme) => ({
    Deleteicon: {
      color:"grey",
      "&:hover, &.Mui-focusVisible": { color: "#FF0027" }
    },
    
     
    }));

export default function ResponsiveDialog() {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      
      <DeleteSweepIcon   className={classes.Deleteicon} onClick={handleClickOpen}/>
      
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" align="center">{"Warning"}</DialogTitle>
        <DialogContent>
          <DialogContentText align="center">
            <img align="center" src="/images/warningicon.svg"/>
          </DialogContentText>
        </DialogContent>
        <DialogContent>
          <DialogContentText>
            Are you sure to delete this report?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{justifyContent: 'center'}}>
        
  <Successpop onClick={handleClose}/>

          <Button onClick={handleClose} variant="contained" style={{ padding: "3px 38px" }} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
